import { uuid } from "@/utils";

export const PROFILE_FIELDS = [
  "_id",
  "user_id",
  "custom_domain",
  "name",
  "slogan",
  "links",
  "description",
  "address",
  "created_at",
  "updated_at",
  "categories",
  "keywords",
  "open_time",
  "share_id",
  "published",
  "streams",
  "products",
  "profile_config"
];

export const allowedOrigins = ["downfor.life"];

export const IMAGE_ALLOWED_KEYS = ["name", "uid", "url"];

export const googleFontUrl = "https://fonts.googleapis.com/css2";

export const ListOfButtonShape = {
  outline: {
    style: {
      borderRadius: 0
    }
  },
  outlinerounded: {
    style: {
      borderRadius: 10
    }
  },
  outlinecircular: {
    style: {
      borderRadius: 30
    }
  }
};

export const CustomLinksLayout = {
  auto: {
    title: "Auto",
    description: "profile-admin-custom-link-shape-auto-description",
    style: {}
  },
  stretch: {
    title: "Stretch",
    description: "profile-admin-custom-link-shape-stretch-description",
    style: {
      fontSize: 18,
      padding: 20,
      width: "100%"
    }
  }
};

export const FontSchema = {
  roboto: 'Roboto:wght@400;700;900',
  montserrat: 'Montserrat:wght@400;700;900',
  poppins: 'Poppins:wght@400;700;900',
  raleway: 'Raleway:wght@400;700;900',
  merriweather: 'Merriweather:wght@400;700;900',
};

export const ProfilePayload = {
  custom_domain: null,
  name: null,
  slogan: "Insert here the slogan of your business",
  description: "Insert here the description of your business",
  links: [],
  address: null,
  created_at: new Date(),
  updated_at: new Date(),
  categories: [],
  published: true,
  streams: {},
  images: {
    header: [
      {
        name: null,
        uid: uuid(),
        url: "https://firebasestorage.googleapis.com/v0/b/downfor-life.appspot.com/o/pictures%2Fimage_0.png?alt=media&token=74717c6b-c65e-4463-993a-05f96d461dcf",
      },
      {
        name: null,
        uid: uuid(),
        url: "https://firebasestorage.googleapis.com/v0/b/downfor-life.appspot.com/o/pictures%2Fimage_1.png?alt=media&token=b3d31244-e27c-4332-ace8-7236d9268f16",
      },
      {
        name: null,
        uid: uuid(),
        url: "https://firebasestorage.googleapis.com/v0/b/downfor-life.appspot.com/o/pictures%2Fimage_2.png?alt=media&token=3c7f9ead-b027-49f1-8c4e-e0f62a5cc798",
      },
      {
        name: null,
        uid: uuid(),
        url: "https://firebasestorage.googleapis.com/v0/b/downfor-life.appspot.com/o/pictures%2Fimage_3.png?alt=media&token=c003a0d7-afb8-4731-82a8-d1150e5a1e33",
      },
      {
        name: null,
        uid: uuid(),
        url: "https://firebasestorage.googleapis.com/v0/b/downfor-life.appspot.com/o/pictures%2Fimage_4.png?alt=media&token=29ae5831-09b1-4e39-894f-fdbdef1a7f1b",
      },
    ],
  },
  profile_config: {
    contacts_enabled: false,
    display_name_type: "logo",
    theme: "dark",
    font_color: "#FFFFFF",
    font_family: "roboto",
    background_color: "#000000",
    custom_button_layout: "stretch",
    button_shape: "outlinerounded",
  }
};